import { RoutesPath } from 'utilities/pageUrl';
import { pageUrl } from 'utilities/pageUrl';

import { DEPRECATED_MEMBERSHIP_ACTIVATION } from './InterstitialModal.constants';
import { INTERSTITIAL_MODAL_ACTIVATED_KEY } from './InterstitialModal.constants';

export const activateModal = () => {
  sessionStorage.setItem(INTERSTITIAL_MODAL_ACTIVATED_KEY, 'true');
};

export const deactivateModal = () => {
  sessionStorage.removeItem(INTERSTITIAL_MODAL_ACTIVATED_KEY);
};

export const checkShouldRedirectBackToMembership = (
  locationPathname: string,
  locationSearch: string,
  open: boolean
) => {
  if (!open) return;

  const shouldRedirectBackToMembership =
    locationSearch === DEPRECATED_MEMBERSHIP_ACTIVATION ||
    locationPathname === RoutesPath.ENTER_MEMBERSHIP_ACCESS_CODE;

  if (shouldRedirectBackToMembership) {
    localStorage.setItem('redirectBackToMembership', 'true');
  }

  const shouldRedirectBackToBooking = locationPathname === pageUrl.createAccount();
  if (shouldRedirectBackToBooking) {
    localStorage.setItem('redirectBackToBooking', 'true');
    localStorage.setItem('redirectBackToBookingUrl', `${locationPathname}${locationSearch}`);
  }
};

export const getProceedButtonProps = () => {
  const redirectBackToMembership = localStorage.getItem('redirectBackToMembership');

  if (redirectBackToMembership) {
    return {
      pathname: RoutesPath.ENTER_MEMBERSHIP_ACCESS_CODE,
      text: 'Proceed to Activate Benefit'
    };
  }

  const location = window.location;

  if (location.pathname === pageUrl.createAccount()) {
    return { pathname: '', text: 'Proceed to Appointment Booking' };
  }

  if (location.pathname === '/my-profile') {
    return { pathname: pageUrl.myProfile('contact'), text: 'Proceed to My Profile' };
  }

  return { pathname: '/', text: 'Proceed to Dashboard' };
};

export const formatAsList = (array: string[], prefix: string): string => {
  try {
    // Our current TS types don't support the Intl.ListFormat
    // @ts-ignore-next-line
    const formatter = new Intl.ListFormat('en');
    return `${prefix}${formatter.format(array)}`;
  } catch {
    return `${prefix}${array.join(', ')}`;
  }
};
